import React, { useState } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { useComponentProperties } from "../../../../Hooks/Display/useComponentProperties";
import ErrorMessage from "../../../Shared/Error/ErrorMessage";
import { useTranslation } from "react-i18next";

function EditTabDialog({ onClose, selectedTab }) {

    const { t } = useTranslation("display/components/tab_container", { useSuspense: false });

    const [labelError, setLabelError] = useState({
        isValid: true,
        message: ""
    });

    const [properties, updateGeneralProperty] = useComponentProperties();

    const [label, setLabel] = useState(selectedTab.label);

    function handleLabel(event) {
        const label = event.target.value.trim();
        const labels = properties.children.filter((item) => item.id !== selectedTab.id).map((item) => item.label.toLowerCase());
        const checkForDuplicate = labels.includes(label.toLowerCase());
        setLabelError({
            isValid: !checkForDuplicate,
            message: checkForDuplicate ? t("editTabDialog.errors.tab_exist") : ""
        });
        setLabel(event.target.value);
    }

    async function onUpdate(event) {
        event.preventDefault();
        const updatedChildren = properties.children.map((item) => {
            if (item.id === selectedTab.id) {
                return {
                    ...item,
                    label: label
                }
            }
            return item;
        });
        updateGeneralProperty("children", structuredClone(updatedChildren))
        onClose();
    }

    function shouldDisableSave() {
        const labels = properties.children.map((item) => item.label.toLowerCase());
        if (!label || labels.includes(label.toLowerCase().trim())) {
            return true;
        }
        return false;
    }

    return (
        <Dialog
            title={t("editTabDialog.title")}
            onClose={onClose}
        >
            <div>
                <div className="me-1 form-label d-inline-block" required>
                    {t("editTabDialog.label")}
                </div>
                <ErrorMessage
                    valid={labelError.isValid}
                    error={labelError.message}
                />
                <input
                    maxLength={64}
                    onChange={handleLabel}
                    value={label}
                    className="form-control name-text"
                    autoFocus={true}
                    type="text"
                />
            </div>
            <DialogActionsBar layout={"end"}>
                <div className="mb-3 me-3">
                    <button className="btn btn-secondary" onClick={onClose}>
                        {t("editTabDialog.buttons.cancelButtonText")}
                    </button>
                    <button
                        disabled={shouldDisableSave()}
                        className="btn btn-primary"
                        onClick={onUpdate}
                    >
                        {t("editTabDialog.buttons.updateButtonText")}
                    </button>
                </div>
            </DialogActionsBar>
        </Dialog >
    )
}

export default EditTabDialog;